<template>
    <div class="top">
        <div style="display: flex;" @click="ind">
            <div class="image">
                <img src="../image/jiaotang.png" alt="" width="24px" height="56px">
            </div>
            <div class="cont">
                <div class="wz">
                    济南市基督教长春里教堂
                  <meta name="description" content="济南市基督教长春里教堂，提供基督教活动场所，齐来崇拜、信仰之门、生命之粮、团契之家。"><meta name="keywords" content="基督教堂, 济南市长春里堂, 基督教, 长春里堂，济南市基督教长春里教堂">
                </div>
                <div class="py">
                    Jinan&nbsp;Chang-chun-li&nbsp;Christian&nbsp;Church
                </div>
            </div>
        </div>

        <div class="search">
            <input type="text" class="frame" placeholder="请输入文字" v-model="name">
            <img src="../image/search.png" alt="" width="14px" height="14px"
                style="position: absolute;top: 43px;left: 15px;">
            <button class="sousuo" @click="searchs">
                <p style="width: 18px;height: 9px;">搜索</p>
            </button>
        </div>
      <div class="search1">
        <button class="sousuo1" @click="mebf" sytle="">
          <p style="width: 18px;height: 9px;">登录</p>
        </button>
      </div>

      <el-dialog :visible.sync="dialogFormVisible" title="手机号登录">
        <el-form :model="form">
          <el-form-item :label-width="formLabelWidth" label="手机号码">
            <el-input v-model="form.phone" autocomplete="off" style="width: 300px;"></el-input>
          </el-form-item>
          <!-- <el-form-item label="图片验证" :label-width="formLabelWidth">
              <el-input v-model="form.captcha" autocomplete="off" style="width: 300px;"></el-input>
              <img :src="img" alt="" @click="captcha" style="height: 20px;width: 100px;">
          </el-form-item> -->
          <el-form-item :label-width="formLabelWidth" label="短信验证">
            <el-input v-model="form.dx" autocomplete="off" style="width: 300px;"></el-input>
            <el-button :disabled="countdown > 0" @click="startCountdown">
              {{ countdown > 0 ? countdown + '秒' : '发送验证码' }}
            </el-button>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit">登 录</el-button>
        </div>
      </el-dialog>

    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return {
          name: "",
          form: {
            phone: '',
            captcha: '',
            date1: '',
            date2: '',
            delivery: false,
            type: [],
            resource: '',
            desc: '',
          },
          formLabelWidth: '120px',
          img: "https://www.jnccljh.com/api/images",
          dialogFormVisible: false,
          countdown: 0,
          timer: null
        }
    },
    created() {

    },
    methods: {

      mebf(item) {
        console.log(localStorage.getItem("token"))
        if (localStorage.getItem("token") != null) {
          this.$message({
            showClose: true,
            message: '已成功登录！',
            type: 'success',
            center: true
          });
        } else {
          this.dialogFormVisible = true
        }
      },

      startCountdown() {
        if (this.form.phone == "") {
          this.$message({
            message: '请输入手机号',
            type: "error"
          })
          return
        }
        // 调用发送验证码接口
        const data = {"account": this.form.phone};
        axios.post('https://www.jnccljh.com/api/sms', data);
        this.countdown = 59;
        this.timer = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      },

      submit() {
        this.dialogFormVisible = false
        const data = {"account": this.form.phone, thirdType: "SMS", mobileText: this.form.dx};
        axios.post('https://www.jnccljh.com/api/login', data).then(res => {
          console.log(res)
          if (res.data.data.accessToken != "") {
            this.$message({
              message: '登录成功',
              type: 'success'
            });
            localStorage.setItem("token", res.data.data.accessToken)
          }
        })
      },

        searchs() {

            axios({
                method: "GET",
                url: "https://www.jnccljh.com/api/searches?name=" + this.name
            }).then(res => {
                console.log(res)
                if(res.data.data.length == 0){
                    this.$message({
          showClose: true,
          message: '没有此内容',
          type: 'error'
        });
                }else{
                    this.$router.push({path:"/search",query:{name:this.name}})
                }
                // this.tlist = res.data.data
            })
        },
        ind(){
            this.$router.push({path:"/"})
        }
    }
}
</script>
<style scoped>
.top {
    width: 70%;
    margin: 0 auto;
    height: 76px;
    background-color: #F7F7F7;
    display: flex;
    justify-content: space-between;
}

.image {
    /* margin-left: 15%; */
    padding-top: 10px;
}

.cont {
    height: 28px;
    display: flex;
    margin-left: 10px;
    flex-direction: column;
    justify-content: center;
    font-size: .2125rem;
    line-height: 13px;
    padding-top: 37px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #333333;
}

/*.search {*/
/*    margin-left: 30%;*/
/*    padding-top: 37px;*/
/*    position: relative;*/
/*    display: flex;*/
/*}*/

.search {
  margin-left: 57%;
  padding-top: 37px;
  position: relative;
  display: flex;
}

.search1 {
  /*margin-left: 30%;*/
  padding-top: 37px;
  position: relative;
  display: flex;
}

.frame {
    width: 135px;
    height: 23.5px;
    border-radius: 5px 0px 0px 5px;
    border: 1px solid #217BFF;
    outline: none;
    padding-left: 44px;
    font-weight: 400;
    font-size: 9px;
    font-family: PingFangSC, PingFang SC;
    line-height: 9px;
}

.sousuo {
    width: 49px;
    height: 27.5px;
    background: #217BFF;
    border-radius: 0px 5px 5px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    outline: none;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 9px;
    color: #FFFFFF;
    line-height: 9px;
    text-align: left;
    font-style: normal;
}

.sousuo1 {
  width: 49px;
  height: 27.5px;
  background: #217BFF;
  border-radius: 5px 5px 5px 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 9px;
  color: #FFFFFF;
  line-height: 9px;
  text-align: left;
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/top.vue